/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDto } from '../../models/paginated-dto';
import { UserListItemDto } from '../../models/user-list-item-dto';

export interface UserControllerFindAll$Params {
  email?: string;
  rolle?: 'Admin' | 'Bueroleitung' | 'BueroMA';
  officeId?: number;
  page: number;
  limit: number;
  sortCol?: string;
  sortDir?: 'ASC' | 'DESC';
  deleted?: boolean;
}

export function userControllerFindAll(http: HttpClient, rootUrl: string, params: UserControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<UserListItemDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, userControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('email', params.email, {});
    rb.query('rolle', params.rolle, {});
    rb.query('officeId', params.officeId, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortCol', params.sortCol, {});
    rb.query('sortDir', params.sortDir, {});
    rb.query('deleted', params.deleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDto & {
      'items'?: Array<UserListItemDto>;
      }>;
    })
  );
}

userControllerFindAll.PATH = '/api/user';
